
import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AppCommonModule } from 'src/app/common.module';
import { SiteArea } from 'src/app/models/site-area.model';
import { AiBuilding } from 'src/app/services/ai.service';
import { ModalShellComponent } from 'src/app/ui/modal-shell/modal-shell.component';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAiBuilding = (object: any): object is AiBuilding => {
  if (object == null || typeof object === 'string') {
    return false;
  }
  return 'label' in object;
};


@Component({
  selector: 'app-edit-area-dialog',
  templateUrl: './edit-area.dialog.html',
  styleUrls: ['./edit-area.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    ModalShellComponent,
  ],
})
export class EditAreaDialogComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private modalCtrl = inject(ModalController);

  item = input<SiteArea | AiBuilding>();
  formGroup: FormGroup;

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      name: [this.item().name, Validators.required],
      label: [''],
      size: [this.item().size],
      volume: [this.item().volume],
      height: [this.item().height],
      internal_doors: [this.item().internal_doors],
      external_doors: [this.item().external_doors],
      windows: [this.item().windows],
    });
    const item = this.item();
    if (isAiBuilding(item)) {
      this.formGroup.get('label').setValue(item.label);
    }
  }

  save() {
    const item = this.formGroup.value;
    this.modalCtrl.dismiss(item);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
